import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=2570286a&scoped=true"
import script from "./setting.vue?vue&type=script&lang=js"
export * from "./setting.vue?vue&type=script&lang=js"
import style0 from "./setting.vue?vue&type=style&index=0&id=2570286a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2570286a",
  null
  
)

export default component.exports